import React from "react"
import { graphql, navigate } from "gatsby"
import { Link } from "gatsby"
import focalPointToObjectPosition from "../utils/object-position"

export const query = graphql`
  fragment ArticleTeaserFields on DatoCmsArticle {
    id
    key
    title
    articleType
    slug
    publishedDate(formatString: "D MMMM, YYYY")
    categories {
      id
      name
    }
    category {
      ...ArticleCategoryFields
    }
    tags {
      id
      name
    }
    image {
      url(imgixParams: { w: "800" })
      focalPoint {
        x
        y
      }
    }
  }
`

interface ArticleTeaserProps {
  article: Queries.ArticleTeaserFieldsFragment
}

const ArticleTeasers = ({ article }: ArticleTeaserProps) => {
  const imageUrl = (article.image && article.image.url) || ""

  return (
    <div
      className="c-article-teaser"
      data-faux-href={article.slug}
      onClick={() => navigate(article.slug)}
    >
      <div className="c-article-teaser__img-holder">
        <div
          className="c-article-teaser__img"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition:
              article.image && article.image.focalPoint
                ? focalPointToObjectPosition(article.image.focalPoint)
                : "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        />
      </div>
      <div className="c-article-teaser__content">
        <p className="c-article-teaser__date">{article.publishedDate}</p>
        <h3 className="c-preamble">
          <Link to={article.slug}>{article.title}</Link>
        </h3>
      </div>
    </div>
  )
}

export default ArticleTeasers
